export const ASSETS_SKILLS_BASE_PATH = `${process.env.PUBLIC_URL}/assets/skills/`;
export const ASSETS_BASE_PATH = `${process.env.PUBLIC_URL}/assets/`;
